var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserVoice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_897_2588)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 10.9996C0.5 9.93874 0.921427 8.92132 1.67157 8.17117C2.42172 7.42103 3.43913 6.9996 4.5 6.9996C5.56087 6.9996 6.57828 7.42103 7.32843 8.17117C8.07857 8.92132 8.5 9.93874 8.5 10.9996H0.5ZM4.5 6.4996C2.8425 6.4996 1.5 5.1571 1.5 3.4996C1.5 1.8421 2.8425 0.499602 4.5 0.499602C6.1575 0.499602 7.5 1.8421 7.5 3.4996C7.5 5.1571 6.1575 6.4996 4.5 6.4996ZM9.123 1.5916C9.37272 2.19668 9.50082 2.84502 9.5 3.4996C9.50082 4.15419 9.37272 4.80252 9.123 5.4076L8.2845 4.7976C8.42758 4.37982 8.5004 3.94121 8.5 3.4996C8.50056 3.05803 8.42791 2.61941 8.285 2.2016L9.123 1.5916ZM10.774 0.391602C11.2531 1.35752 11.5016 2.4214 11.5 3.4996C11.5 4.6161 11.2385 5.6716 10.774 6.6076L9.9515 6.0096C10.3141 5.22258 10.5013 4.36613 10.5 3.4996C10.5 2.6036 10.3035 1.7531 9.9515 0.989602L10.774 0.391602Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_897_2588"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserVoice);
export default __webpack_public_path__ + "static/media/user-voice.182be7b0566eda6d7d1442d089c3fa28.svg";
export { ForwardRef as ReactComponent };